export const isBottomRightCornerOfRectangle = ({
  cellId,
  selectionGrid,
  lastRowIndex,
  lastCellIndex,
  entityMap,
  pathToIndex
}) => {
  selectionGrid.forEach((row) => {
    while (row[0] === void 0 && row.length) row.shift();
  });
  const [rowId, cellPath] = cellId.split(":");
  const ent = entityMap[rowId];
  if (!ent) return;
  const { i } = ent;
  const cellIndex = pathToIndex[cellPath];
  const isBottomRight = i === lastRowIndex && cellIndex === lastCellIndex;
  return isBottomRight;
};
